module.exports = __webpack_public_path__ + "static/media/OpenSans_Regular.3ed9575d.ttf";